












































import {Component, Watch, Vue} from 'vue-property-decorator'
import {Getter, Action} from 'vuex-class'
import {$, Collection, successAndPush} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import Responsavel from '@/model/resource/Responsavel'
import StatusSms from '@/model/resource/StatusSms'
import ResponsavelConfigSms from '@/model/resource/ResponsavelConfigSms'
import ResponsavelConfigSmsRequest from '@/model/request/ResponsavelConfigSmsRequest'
import TipoOcorrencia from '@/model/resource/TipoOcorrencia'
import {getResponsavel, ItrackCollection} from '@/helpers'
import * as Helper from '@/helpers'

const metaInfo = () => ({
  title: $.t('view.manage.smsNotificationSettings.title'),
})

@Component({
  metaInfo,
})
export default class ManageSmsNotificationsSettingsView extends Vue {
  @Action('auth/auth') auth!: Function
  @Getter('auth/responsavel') responsavelCache!: Responsavel

  AppConfig = AppConfig

  config = new ResponsavelConfigSmsRequest()
  possibleSmsStatus = new Collection(StatusSms)
  allTipoOcorrencia = ItrackCollection.allTipoOcorrencia
  ocorrencias = new Collection(TipoOcorrencia)

  async mounted() {
    this.config.responsavel = this.responsavelCache.clone()
    await this.config.populate('load')
    await this.possibleSmsStatus.query()
    await this.allTipoOcorrencia.query()

    const filterNaoDevolvida = this.allTipoOcorrencia.items.filter((item) =>
      // @ts-ignore
      (item.responsavel.$id === getResponsavel().$id || !item.responsavel.$id))

    this.ocorrencias = Helper.collect(TipoOcorrencia, filterNaoDevolvida)
  }

  addSms() {
    this.config.list.push(new ResponsavelConfigSms())
  }

  removeSms(i: number) {
    this.config.list.splice(i, 1)
  }

  async persist() {
    if (this.config.list.some((cfg) => !Boolean(cfg.statusSms && cfg.statusSms.idStatusPk))) {
      await Helper.abort('system.error.statusFieldCantBeEmpty')
    }

    await this.config.save()
    await this.auth()
    successAndPush('system.success.persist', 'cockpit')
  }
}
